import React, { useState } from "react";
import { Link } from "react-router-dom";
import FinAbtUs from "../../../assets/images/Finrelaible about us (19200x540).png";

function Main() {
  const [video, setVideo] = useState();

  const data = [
    {
      id: 1,
      name: "Company mission",
      desc: "To deliver simple, affordable, and transparent insurance solutions backed by expert customer support."
    },
    {
      id: 2,
      name: "Company vision",
      desc: "To be the most trusted and customer-focused insurance provider, offering reliable protection and peace of mind."
    },
    {
      id: 3,
      name: "Best Features",
      desc:"Quick and hassle-free claim settlement, affordable and transparent premiums, Fully digital and easy-to-use services."
    },
  ];
  return (
    <>
      <section className="about-five">
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-md-12 col-lg-7">
              <div className="about-one__image">
                <img src={FinAbtUs} style={{ width: '655px', height: '620px' }} />
                {/* <Link
                  to="#"
                  className="video-popup about-one__video"
                  onClick={() => setVideo(true)}
                >
                  <i className="fa fa-play" />
                  <span>Play</span>
                </Link> */}
                <div className="about-five__image__caption">
                  <h3 className="about-five__image__caption__title">
                    2 Years Of Experience in Insurance Services
                  </h3>

                  <p className="about-five__image__caption__text">
                    CEO &amp; Founder
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-5 d-flex">
              <div className="my-auto">
                <div className="about-five__content">
                  <div className="sec-title text-start">
                    <p className="sec-title__tagline">About company</p>

                    <h3 className="sec-title__title">
                      Award winning insurance company since 2023
                    </h3>
                  </div>

                  <div className="about-five__content__text">
                    We are an award-winning insurance provider, proudly serving customers since 2023. With trusted coverage, transparent processes, and customer-first service, we ensure protection that truly matters - when it matters the most.
                  </div>




                </div>
              </div>
            </div>
          </div>
        </div>

        {video && (
          <div
            className={`YouTubePopUp-Wrap ${video && "YouTubePopUp-hide"}`}
            onClick={() => {
              setVideo(false);
            }}
          >
            <div className="YouTubePopUp-Content">
              <span className="YouTubePopUp-Close" />
              <iframe
                src="https://www.youtube.com/embed/CWCPovmNWK8?autoplay=1"
                allowFullScreen=""
              />
            </div>
          </div>
        )}
      </section>

      <section className="about-four">
        <div className="container">
          <div className="row gutter-y-30">
            {data.map((item) => (
              <div
                key={item.id}
                className="col-md-12 col-lg-4 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="000ms"
              >
                <div className="about-four__card">
                  <div className="about-four__card__icon">
                    <i className="fas fa-check" />
                  </div>

                  <h3 className="about-four__card__title">
                    <Link to="#"> {item.name} </Link>
                  </h3>

                  <div className="about-four__card__text">
                   {item.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Main;
